import { render, staticRenderFns } from "./WithLabel.vue?vue&type=template&id=eede9d72"
import script from "./WithLabel.vue?vue&type=script&lang=js"
export * from "./WithLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports